/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  IProgressIndicatorStyles,
  IProgressIndicatorStyleProps,
} from "office-ui-fabric-react/lib/ProgressIndicator";
/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { getTheme, FontSizes, FontWeights } from "office-ui-fabric-react/lib/Styling";
import { IStyleFunctionOrObject } from "office-ui-fabric-react/lib/Utilities";
import styled from "styled-components";

const theme = getTheme();

/**
 * Styled div for character counter.
 */
export const CharacterCounterDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

/**
 * The Character Counter Styles.
 * @param {boolean} alertDescription Flag indicating whether to alert item description.
 * @returns {IStyleFunctionOrObject} The style function object.
 */
export const characterCounterStyles: (
  alertDescription: boolean
) => IStyleFunctionOrObject<IProgressIndicatorStyleProps, IProgressIndicatorStyles> = (
  alertDescription: boolean
) => {
  return {
    itemDescription: {
      color: alertDescription ? theme.palette.red : theme.palette.black,
      fontWeight: FontWeights.semibold,
      display: "flex",
      justifyContent: "flex-end",
    },
    itemName: {
      fontSize: FontSizes.small,
      fontWeight: FontWeights.semibold,
    },
  };
};
